export default "__VITE_ASSET__ChBJkyS9__"